import { escapeRegExp } from "../../lib/filter-utils";
/**
 * Highlights case-insensitive matches of filter text within a measurement label.
 *
 * @param {{
 *   label: string,
 *   filterText?: string,
 * }} props
 */
export default function RcaMeasurementLabelHighlight({
  label,
  filterText = "",
}) {
  const query = filterText.trim();
  if (!query) return label;

  const parts = label.split(new RegExp(`(${escapeRegExp(query)})`, "ig"));
  const lowerQuery = query.toLowerCase();

  return (
    <>
      {parts.map((part, index) => {
        if (!part) return null;
        const isMatch = part.toLowerCase() === lowerQuery;
        return isMatch ? (
          <mark
            key={`${part}-${index}`}
            className='rounded bg-amber-200/80 px-0.5 text-inherit dark:bg-amber-500/35'>
            {part}
          </mark>
        ) : (
          <span key={`${part}-${index}`}>{part}</span>
        );
      })}
    </>
  );
}
